"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorCarouselArray = exports.ColorCarouselTheme = exports.settings = exports.BACKDROP_OFFSET = exports.SLIDES_TO_SHOW_EXTRA_MOBILE = exports.SLIDES_TO_SHOW_MOBILE = exports.SLIDES_TO_SHOW_TABLE = exports.SLIDES_TO_SHOW_LAPTOP = exports.SLIDES_TO_SHOW_DEFAULT = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var SLIDES_TO_SHOW_DEFAULT = 8;
exports.SLIDES_TO_SHOW_DEFAULT = SLIDES_TO_SHOW_DEFAULT;
var SLIDES_TO_SHOW_LAPTOP = 6;
exports.SLIDES_TO_SHOW_LAPTOP = SLIDES_TO_SHOW_LAPTOP;
var SLIDES_TO_SHOW_TABLE = 6;
exports.SLIDES_TO_SHOW_TABLE = SLIDES_TO_SHOW_TABLE;
var SLIDES_TO_SHOW_MOBILE = 4;
exports.SLIDES_TO_SHOW_MOBILE = SLIDES_TO_SHOW_MOBILE;
var SLIDES_TO_SHOW_EXTRA_MOBILE = 3;
exports.SLIDES_TO_SHOW_EXTRA_MOBILE = SLIDES_TO_SHOW_EXTRA_MOBILE;
var BACKDROP_OFFSET = 50;
exports.BACKDROP_OFFSET = BACKDROP_OFFSET;

var settings = function settings(slides) {
  return {
    infinite: true,
    slidesToShow: slides >= SLIDES_TO_SHOW_DEFAULT ? SLIDES_TO_SHOW_DEFAULT : slides,
    variableWidth: slides < SLIDES_TO_SHOW_DEFAULT,
    arrows: true,
    swipeToSlide: true,
    dots: false,
    lazyLoad: 'progressive',
    responsive: [{
      breakpoint: Number(_uiKit.GridBreakpointsMax.xl),
      settings: {
        slidesToShow: slides >= SLIDES_TO_SHOW_LAPTOP ? SLIDES_TO_SHOW_LAPTOP : slides,
        variableWidth: slides < SLIDES_TO_SHOW_LAPTOP
      }
    }, {
      breakpoint: Number(_uiKit.GridBreakpointsMax.lg),
      settings: {
        slidesToShow: slides >= SLIDES_TO_SHOW_TABLE ? SLIDES_TO_SHOW_TABLE : slides,
        arrows: false,
        variableWidth: true
      }
    }, {
      breakpoint: Number(_uiKit.GridBreakpointsMax.md),
      settings: {
        slidesToShow: slides >= SLIDES_TO_SHOW_MOBILE ? SLIDES_TO_SHOW_MOBILE : slides,
        arrows: false,
        variableWidth: true
      }
    }, {
      breakpoint: 360,
      settings: {
        slidesToShow: slides >= SLIDES_TO_SHOW_EXTRA_MOBILE ? SLIDES_TO_SHOW_EXTRA_MOBILE : slides,
        arrows: false,
        variableWidth: true
      }
    }]
  };
};

exports.settings = settings;
var ColorCarouselTheme;
exports.ColorCarouselTheme = ColorCarouselTheme;

(function (ColorCarouselTheme) {
  ColorCarouselTheme["WHITE"] = "white";
  ColorCarouselTheme["SEASHELL"] = "seashell";
  ColorCarouselTheme["SEASHELL_ALT"] = "seashell-alt";
  ColorCarouselTheme["MOCASSIN"] = "mocassin";
  ColorCarouselTheme["MOCASSIN_ALT"] = "mocassin-alt";
  ColorCarouselTheme["CLARET"] = "claret";
  ColorCarouselTheme["CLARET_ALT"] = "claret-alt";
  ColorCarouselTheme["BLACK"] = "black";
  ColorCarouselTheme["BLACK_ALT"] = "black-alt";
})(ColorCarouselTheme || (exports.ColorCarouselTheme = ColorCarouselTheme = {}));

var colorCarouselArray = Object.values(ColorCarouselTheme);
exports.colorCarouselArray = colorCarouselArray;